import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
   useDynamicComponentImport,
   PAGE_SEGMENT_KEY,
   GLOBA_SEGMENT_KEY,
} from 'admin/views/site-designer/data';
import {
   upperCaseFirstLetter,
} from 'common/utils/utils';

const SiteDesignerRightSide = ({
   activeEditableSection,
   onClickSection,
   desktopType,
   isShowFullScreen,
   isDarkMode,
   rightSide,
   isPrepearComponentForRender,
   segmentType,
   pageSections,
   globalSettings,
}) => {
   const getLoadArgs = () => {
      let path = '';
      let pathSuffix = '';
      if('mms_page_template' === rightSide){
         pathSuffix = 'page-template';
         path = 'admin/views/site-designer/right-side';
         return [pathSuffix, path];
      }
      if(PAGE_SEGMENT_KEY === rightSide){
         pathSuffix = 'page-template';
         path = 'admin/views/site-designer/right-side';
      } else if(GLOBA_SEGMENT_KEY === segmentType) {
         path = 'admin/views/site-designer/right-side/components';
         pathSuffix = rightSide;
      } else if(rightSide && 'string' === typeof rightSide){
         path = 'admin/views/site-designer/right-side/pages';
         pathSuffix = upperCaseFirstLetter(rightSide);

      }
      return [pathSuffix, path];
   }
   const { Component, isLoadComponent, notFoundComponent } = useDynamicComponentImport(...getLoadArgs());
   const loadSection = isLoadComponent;
   const props = {
      activeEditableSection: activeEditableSection,
      onClickSection: onClickSection,
      pageSections: pageSections,
      globalSettings: globalSettings,
      isMobile: desktopType === 'mobile',
   }
   return (
      <div
         id='dashboard-sitedesing-preview'
         className={ cx({
            'relative overflow-y-auto ams-custom-scrool site-builder-transition mx-auto': true,
            'h-[calc(100%-24px)] border rounded-t-label': !isShowFullScreen,
            'dark mode-dark bg-black': isDarkMode,
            'bg-panel border-divider': !isDarkMode,
            'w-[375px]': 'mobile' === desktopType,
            'w-full': 'desktop' === desktopType,
         }) }
      >
         <Suspense
            fallback={
               <div
                  className='loading-bg bg-placeholder rounded-lg w-full my-auto h-full'
               />
            }
         >
            {
               notFoundComponent && (
                  <>
                     {rightSide}
                  </>
               )
            }
            {
               !loadSection && !notFoundComponent && !isPrepearComponentForRender && (
                  <>
                     <Component
                        { ...props }
                     />
                  </>
               )}
            {
               (loadSection || isPrepearComponentForRender) && (
                  <div
                     className='loading-bg bg-placeholder rounded-lg w-full my-auto h-full' />
               )
            }
         </Suspense>
      </div>
   )
}

SiteDesignerRightSide.propTypes = {
   pageSections: PropTypes.object,
   globalSettings: PropTypes.object,
   activeEditableSection: PropTypes.string,
   onClickSection: PropTypes.func,
   desktopType: PropTypes.string,
   isShowFullScreen: PropTypes.bool,
   isDarkMode: PropTypes.bool,
   isPrepearComponentForRender: PropTypes.bool,
   rightSide: PropTypes.string,
   segmentType: PropTypes.string,
}

export default SiteDesignerRightSide;
